import { Check } from "lucide-react";

const FOUNDING_PAYPAL_URL = "https://www.paypal.com/ncp/payment/KYERFXL4ZYLL8";

const FoundingLink = ({ testId, className, children }) => (
  <a
    href={FOUNDING_PAYPAL_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className={className}
  >
    {children}
  </a>
);

const PERKS = ["Unlimited likes", "See who liked you", "Voice messages", "Read receipts", "Priority in Discover"];

const PerkList = ({ testId }) => (
  <ul className="mt-8 space-y-3" data-testid={testId}>
    {PERKS.map((perk) => (
      <li key={perk} className="flex items-center gap-3 text-sm text-[#1C1612]/80">
        <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold/15">
          <Check className="h-3 w-3 text-gold" />
        </span>
        {perk}
      </li>
    ))}
  </ul>
);

export const MonthlyCard = () => (
  <div className="flex h-full flex-col rounded-3xl border border-[#1C1612]/10 bg-[#F7F1E6] p-8 md:p-10" data-testid="pricing-card-monthly">
    <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#1C1612]/55">Monthly</p>
    <div className="mt-6 flex items-end gap-2">
      <span className="font-serif text-5xl tracking-tight text-[#1C1612]" data-testid="pricing-monthly-price">$29.99</span>
      <span className="pb-1.5 text-sm text-[#1C1612]/60">/month</span>
    </div>
    <p className="mt-3 text-sm leading-relaxed text-[#1C1612]/75">Opens the founding member payment in PayPal.</p>
    <PerkList testId="pricing-monthly-perks" />
    <FoundingLink
      testId="pricing-monthly-cta"
      className="mt-10 block w-full rounded-full border border-gold/40 px-8 py-4 text-center text-sm font-bold uppercase tracking-[0.15em] text-gold transition-colors duration-300 hover:bg-gold hover:text-ink active:scale-95"
    >
      Choose Monthly
    </FoundingLink>
  </div>
);

export const YearlyCard = () => (
  <div className="relative flex h-full flex-col rounded-3xl border border-gold bg-[#F7F1E6] p-8 md:p-10" data-testid="pricing-card-yearly">
    <span className="absolute -top-3.5 left-8 rounded-full bg-gold px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.15em] text-ink" data-testid="pricing-yearly-badge">
      BEST VALUE — SAVE $209.89
    </span>
    <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold">Yearly</p>
    <div className="mt-6 flex items-end gap-2">
      <span className="font-serif text-5xl tracking-tight text-[#1C1612]" data-testid="pricing-yearly-price">$149.99</span>
      <span className="pb-1.5 text-sm text-[#1C1612]/60">/year</span>
    </div>
    <p className="mt-3 text-sm leading-relaxed text-[#1C1612]/75">Just $12.50 a month, paid through the founding member link.</p>
    <div className="mt-4 rounded-2xl border border-gold/30 bg-gold/10 px-4 py-3" data-testid="pricing-founding-ribbon">
      <p className="text-xs font-bold uppercase tracking-[0.12em] text-gold">Founding member deal</p>
      <p className="mt-1 text-sm leading-relaxed text-[#1C1612]/75">
        Your first year: <span className="font-semibold text-gold">$75</span>{" "}
        <span className="text-[#1C1612]/40 line-through">$149.99</span> — 50% off. Payment opens in PayPal.
      </p>
    </div>
    <PerkList testId="pricing-yearly-perks" />
    <FoundingLink
      testId="pricing-yearly-cta"
      className="btn-glow mt-10 block w-full rounded-full bg-gold px-8 py-4 text-center text-sm font-bold uppercase tracking-[0.15em] text-ink hover:bg-gold-deep active:scale-95"
    >
      Choose Yearly
    </FoundingLink>
  </div>
);
